import styled from "@emotion/styled/macro";
import ResetButton from "../../common/ResetButton";

const ButtonBase = styled(ResetButton)`
  &:before {
    content: "";
    display: block;
    width: 55px;
    height: 55px;
    border-radius: 50%;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    background-position: center center;
    background-size: contain;
    background-repeat: no-repeat;
    margin: 0 auto;
  }

  position: absolute;
  top: 60px;
  right: 10px;
  min-width: 63px;
  z-index: 1;

  &:active {
    top: 62px;
    &:before {
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
    }
  }

  &:after {
    font-size: 11px;
  }
`;

export default ButtonBase;
